import React, { useState, useEffect } from "react";

import { connect } from "react-redux";
import Flag from "semantic-ui-react/dist/es/elements/Flag";
import { toast } from "react-toastify";
import { components } from "react-select";

import "../../../../SettingsContainer/InstagramHashTag/InstagramHashTag.scss";

import { ReactComponent as GlobeIcon } from "../../../../../assets/svg/globe-icon.svg";
import { ReactComponent as CuraCao } from "../../../../../assets/svg/curacao.svg";
import { ReactComponent as BonaireIcon } from "../../../../../assets/svg/bonaire.svg";
import { ReactComponent as Guernsey } from "../../../../../assets/svg/guernsey.svg";
import { ReactComponent as Isleofman } from "../../../../../assets/svg/Isleofman.svg";
import { ReactComponent as Bostonian } from "../../../../../assets/svg/bostonian.svg";
import { ReactComponent as UnknownFlag } from "../../../../../assets/svg/unknown-flag.svg";
import { ReactComponent as SintMarteen } from "../../../../../assets/svg/sint-maarten.svg";
import { ReactComponent as SouthSudan } from "../../../../../assets/svg/South-Sudan.svg";
import { ReactComponent as Jersey } from "../../../../../assets/svg/jersey.svg";
import { ReactComponent as SaintBarthelemy } from "../../../../../assets/svg/Saint-Barthelemy.svg";
import { ReactComponent as FilterImage } from "../../../../../assets/svg/filter.svg";

import {
    resetAccountForm,
    setAccountList,
    setAccountListData,
    setValidAccount,
    validateAccount,
    setAccount,
    setEntity,
    setAccountLocation,
    setPublication,
    setPullComments,
    setTiktokKeyword,
    setTiktokRuleName,
    setBulkFileldValue,
    setPostUrl,
    setPostCountry,
    setPostListData,
    setValidCountry,
    setValidEntity,
    setAccountURL,
} from "../../../../../actions/queryBuilderActions";
import { Prompt, Redirect } from "react-router-dom";

function PlatformWrapper(props) {
    const [searchTextValue, setSearchTextValue] = useState("");
    const [statusOption, setStatusOption] = useState([]);
    const [statusText, setStatusText] = useState("");
    const [isFbComment, setIsFbComment] = useState(false);

    const [ruleName, setRuleName] = useState("");
    const [keywords, setKeywords] = useState("");

    const handleRuleNameChange = (ev) => {
        setRuleName(ev.target.value);
        props.checkIsDirty(true);
    };

    const handleKeywordChange = (ev) => {
        setKeywords(ev.target.value);
        props.checkIsDirty(true);
    };

    useEffect(() => {
        return () => {
            props.resetAccountForm();
            props.setValidAccount(false);
            props.closeComponent();
        };
    }, []);

    const myStyle = {
        control: (base) => ({
            ...base,
            border: 0,
            boxShadow: "none",
            background: "#E7E8F0",
            height: "36px",
            minHeight: "36px",
            position: "initial",
            cursor: "pointer",
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return { ...styles, backgroundColor: isSelected ? "#E7E8F0" : null, color: "#1F2E3D" };
        },
        valueContainer: (base) => ({ ...base, paddingLeft: "20px" }),
    };

    const customStyle = {
        control: (base) => ({
            ...base,
            border: 0,
            boxShadow: "none",
            background: "#F7F7F7",
            color: "#1F2E3D",
            cursor: "pointer",
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                backgroundColor: isFocused ? (isSelected ? "#268af6" : "#f2f3ff") : isSelected ? "#268af6" : null,
                color: isSelected ? "white" : "#1F2E3D",
                cursor: "pointer",
            };
        },
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 999999,
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 999999,
        }),
        singleValue: (provided) => {
            return {
                ...provided,
                color: "#1F2E3D",
            };
        },
        dropdownIndicator: (base) => ({
            ...base,
            color: "#697384",
        }),
        clearIndicator: (base) => ({
            ...base,
            color: "#697384",
        }),
    };

    const getCountryList = () => {
        let countries = props.allLocations || [];
        let countryOptions = countries.filter((ele) => {
            return (
                ele.name !== "Abu Dhabi" &&
                ele.name !== "Antarctica" &&
                ele.name !== "Asia" &&
                ele.name !== "Asia-Pacific" &&
                ele.name !== "Middle East" &&
                ele.name !== "Dubai" &&
                ele.name !== "Sharjah" &&
                ele.name !== "Millennium Bostonian"
            );
        });
        let filteredCountryOptions = countryOptions.map((x) => {
            if (
                x.name == "Curacao" ||
                x.name == "Bonaire, Sint Eustatius and Saba" ||
                x.name == "Guernsey" ||
                x.name == "Isle of Man" ||
                x.name == "Millennium Bostonian" ||
                x.name == "Jersey" ||
                x.name == "Saint Martin" ||
                x.name == "Sint Maarten" ||
                x.name == "Worldwide" ||
                x.name == "South Sudan" ||
                x.name == "Saint Barthelemy" ||
                x.name == "Unknown"
            ) {
                return { value: x.id, label: x.name, flag: x.short_name == null ? "" : x.short_name.toLowerCase(), flag_miss: "yes", short_name: x.short_name };
            } else {
                return { value: x.id, label: x.name, flag: x.short_name == null ? "" : x.short_name.toLowerCase(), flag_miss: "no", short_name: x.short_name };
            }
        });
        return filteredCountryOptions;
    };

    const entityList = [
        { label: "Male", value: "male" },
        { label: "Female", value: "female" },
        { label: "Unknown", value: "unknown" },
        { label: "Person-Unknown", value: "person-unknown" },
        { label: "News", value: "news" },
        { label: "Brand", value: "brand" },
    ];

    const activeFilterOptions = [
        { label: "All", value: "all" },
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
        { label: "Deleted", value: "Deleted" },
    ];

    const Control = ({ children, ...props }) => {
        const style = { cursor: "pointer" };
        return (
            <components.Control {...props}>
                <span style={style}>{!!children && <FilterImage style={{ height: "20px", width: "20px", marginTop: "5px", marginRight: "4px" }} />}</span>
                <span className="zzz">{children}</span>
            </components.Control>
        );
    };

    const handleEntityTypeChange = (selectedEntity) => {
        props.setEntity(selectedEntity);
        props.setCheckIsDirty(true);
        // changeAccountStatus();
    };

    const handleLocationChange = (selectedLocation) => {
        props.setAccountLocation(selectedLocation);
        props.setCheckIsDirty(true);
        // changeAccountStatus();
    };

    const handleUrlChange = (e, configurePlatform = "") => {
        if (configurePlatform === "TIKTOK" && e.target.value.length > 0) {
            const regex = /^[a-zA-Z0-9_.]{1,24}$/;
            if (!regex.test(e.target.value)) {
                toast.error("Invalid account name. See iTip for more info.");
                return;
            }
        }

        props.setAccount(e.target.value);
        props.setCheckIsDirty(true);
        changeAccountStatus();
    };

    const handleChUrlChange = (e) => {
        props.setAccountURL(e.target.value);
        props.setCheckIsDirty(true);
        changeAccountStatus();
    };

    const handlePostUrlChange = (e) => {
        props.setPostUrl(e.target.value);
        props.setCheckIsDirty(true);
        changeAccountStatus();
    };

    const handlePostCountryChange = (selectedLocation) => {
        props.setPostCountry(selectedLocation);
        props.setCheckIsDirty(true);
        // changeAccountStatus();
    };

    const onAddAccount = (isPost) => {
        if (!props.bulkMode) {
            if (!isPost) {
                let accountLength = props.accountListData.filter((ac) => ac.platform_name !== "fbcomment").length;

                if (accountLength >= 20) {
                    toast.error("Maximum 20 accounts are allowed at a time.");
                    return;
                }

                const accountName = props.accountName;
                const entity = props.validEntity || props.entityType;
                const country = props.validCountry || props.location;

                const accountObj = {};
                accountObj["account_name"] = accountName;
                accountObj["platform_name"] = props.platformName;
                if (isFbComment) {
                    accountObj["platform_name"] = "fbcomment";
                }
                if (props.platformName === "youtube") {
                    accountObj["youtube_url"] = props.yTAccountURL;
                }
                accountObj["fetch_comment"] = props.fetchComment ? 1 : 0;
                accountObj["news_config"] = props.isPublication ? 1 : 0;
                if (country?.short_name) {
                    accountObj["country"] = country.short_name;
                }
                if (entity?.value) {
                    accountObj["entity_sub_type"] = entity.value;
                }
                let accList = [...props.accountListData, accountObj];
                // accList.push(accountObj);
                props.setAccountListData(accList);

                let stringObj = props.platformName + ":" + accountName + ",";
                if (isFbComment) {
                    stringObj = "fbcomment" + ":" + accountName + ",";
                }
                if (props.platformName === "youtube") {
                    stringObj += `youtube_url:${props.yTAccountURL},`;
                }
                stringObj += `fetch_comment:${props.fetchComment ? 1 : 0},`;
                stringObj += `news_config:${props.isPublication ? 1 : 0},`;

                if (country?.short_name) {
                    stringObj += "country:" + country.short_name + ",";
                }

                if (entity?.value) {
                    stringObj += "entity_sub_type:" + entity.value;
                }
                let bulkeditStringObj = "";
                let prevBulkValue = props.bulkInputValue;
                if (prevBulkValue) {
                    bulkeditStringObj += prevBulkValue;
                    bulkeditStringObj += "\n" + stringObj;
                } else {
                    bulkeditStringObj = stringObj;
                }
                props.setAccountList([stringObj]);
                props.setBulkFileldValue(bulkeditStringObj);
                setTimeout(() => {
                    props.resetAccountForm();
                }, 0);
                props.setValidAccount(false);
            } else {
                onAddPost();
            }
        }

        // if (props.bulkMode) {
        //     let tableList = props.accountListData;
        //     const tableLength = tableList.length;
        //     const bulkFieldValue = props.bulkInputValue.trim();
        //     if (bulkFieldValue == "") {
        //         toast.error("Please add a account");
        //         return;
        //     }
        //     let accountList = bulkFieldValue.split("\n");
        //     const bulkListLength = accountList.length;
        //     if (bulkListLength > 20) {
        //         toast.error("Maximum 20 accounts are allowed in Bulk add");
        //         return;
        //     }

        //     let modifiedList = accountList.map((ele) => {
        //         let temp = ele.split(",");
        //         let accountsListObj = {};
        //         let jsonObject = "{";
        //         temp.forEach(function (t) {
        //             var temp2 = t.split(":");
        //             if (jsonObject.length > 1) {
        //                 jsonObject += ',"' + temp2[0] + '"' + ":" + '"' + temp2[1] + '"';
        //             } else {
        //                 jsonObject += '"' + temp2[0] + '"' + ":" + '"' + temp2[1] + '"';
        //                 accountsListObj.platform_name = temp2[0];
        //                 accountsListObj.account_name = temp2[1];
        //                 if (temp2[2]) {
        //                     accountsListObj.account_name += ":" + temp2[2];
        //                 }
        //             }
        //         });
        //         jsonObject += "}";
        //         jsonObject = JSON.parse(jsonObject);
        //         let combinedObject = { ...accountsListObj, ...jsonObject };
        //         return combinedObject;
        //     });
        //     props.setAccountListData([...modifiedList]);
        // }
    };

    const onAddPost = () => {
        const post_url = props.post_url;
        const post_country = props.validCountry || props.post_country;

        let accountLength = props.accountListData.filter((ac) => ac.platform_name !== "fbcomment").length;

        if (accountLength >= 20) {
            toast.error("Maximum 20 accounts are allowed at a time.");
            return;
        }

        if (post_url === "") {
            toast.error("Post URL can not be empty");
            return;
        }
        if (props.accountListData.find((ac) => ac.account_name === post_url)) {
            toast.error("This post is already added.");
            return;
        }
        if (!post_country || post_country === "") {
            toast.error("Please select a country");
            return;
        }

        let domainCheck = post_url.indexOf("https://www.facebook.com/") == -1;
        let pattern = new RegExp(
            "^(https?:\\/\\/)?" +
                "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
                "((\\d{1,3}\\.){3}\\d{1,3}))" +
                "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
                "(\\?[;&a-z\\d%_.~+=-]*)?" +
                "(\\#[-a-z\\d_]*)?$",
            "i",
        );
        if (!pattern.test(post_url) || domainCheck) {
            toast.error("Please enter a valid Facebook post URL");
            return;
        }
        let splitted_url = post_url.split("https://www.facebook.com/");
        if (splitted_url[1].split("/").length !== 3 || ["posts,videos"].includes(splitted_url[1].split("/")[1])) {
            toast.error("Please enter a valid Facebook post url");
            return;
        }

        const accountObj = {};

        accountObj["account_name"] = post_url;
        accountObj["platform_name"] = "facebook_post";
        accountObj["one_time_fetch"] = false;
        accountObj["country_id"] = post_country.value;
        accountObj["country"] = post_country.short_name;

        let accList = props.accountListData;
        accList.push(accountObj);
        props.setAccountListData(accList);

        let stringObj = "facebook_post:" + post_url + ",country:" + post_country.short_name + ",";
        let bulkeditStringObj = "";
        let prevBulkValue = props.bulkInputValue;
        if (prevBulkValue !== "") {
            bulkeditStringObj += prevBulkValue;
            bulkeditStringObj += "\n" + stringObj;
        } else {
            bulkeditStringObj = stringObj;
        }
        props.setAccountList([stringObj]);
        props.setBulkFileldValue(bulkeditStringObj);

        setTimeout(() => {
            props.resetAccountForm();
        }, 0);
        props.setValidAccount(false);
    };

    const verifyAccount = (post, ytChannelId) => {
        if (!props.bulkMode) {
            const accountName = ytChannelId ? ytChannelId : props.accountName;

            console.log("[account_name]", accountName);

            const location = props.location;
            const entity = props.entityType;
            if (!post) {
                if (accountName === "") {
                    toast.error("Account can not be empty");
                    return;
                }
            } else if (post) {
                if (props.post_url === "") {
                    toast.error("Post URL can not be empty");
                    return;
                }
            }

            if (post) {
                let domainCheck = props.post_url.indexOf("https://www.facebook.com/") == -1;
                let pattern = new RegExp(
                    "^(https?:\\/\\/)?" +
                        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
                        "((\\d{1,3}\\.){3}\\d{1,3}))" +
                        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
                        "(\\?[;&a-z\\d%_.~+=-]*)?" +
                        "(\\#[-a-z\\d_]*)?$",
                    "i",
                );
                if (!pattern.test(props.post_url) || domainCheck) {
                    toast.error("Please enter a valid Facebook post URL");
                    return;
                }
                let splitted_url = props.post_url.split("https://www.facebook.com/");
                if (splitted_url[1].split("/").length !== 3 || ["posts,videos"].includes(splitted_url[1].split("/")[1])) {
                    toast.error("Please enter a valid Facebook post url");
                    return;
                }
            }

            const param = {};
            let stringObj = props.platformName + ":" + accountName.trim() + ",";
            if (isFbComment) {
                stringObj = "fbcomment" + ":" + accountName.trim() + ",";
            }
            if (post) {
                stringObj = "facebook_post" + ":" + props.post_url + ",";
            }
            stringObj += "fetch_comment:0,";
            stringObj += "news_config:0,";
            if (!post && location && Object.keys(location).length > 0) {
                stringObj += "country:" + location.short_name || "Worldwide" + ",";
            } else if (post && props.post_country && Object.keys(props.post_country).length > 0) {
                stringObj += "country:" + props.post_country.short_name || "Worldwide" + ",";
            }
            if (entity && Object.keys(entity).length > 0) {
                stringObj += "entity_sub_type:" + entity.value || "unknown";
            }
            if (props.platformName === "tiktok") stringObj = `tiktok:${accountName.trim()}`;
            param["accounts"] = [stringObj];

            console.log("platformname", props.platformName);
            props.validateAccount(param, props.platformName);
        }
        // if (props.bulkMode) {
        //     const bulkFieldValue = props.bulkInputValue.trim();
        //     if (bulkFieldValue == "") {
        //         toast.error("Please add an account");
        //         return;
        //     }
        //     let accountList = bulkFieldValue.split("\n");
        //     let params = {};
        //     params["accounts"] = accountList;
        //     props.validateAccount(params);
        // }
    };

    const deleteAccount = (ind) => {
        let tableData = [...props.accountListData];
        //Delete one element from the selected index
        tableData.splice(ind, 1);
        let stringObj = "";
        tableData.forEach((ele, ind) => {
            stringObj += ele.platform_name + ":" + ele.account_name + ",";
            if ("fetch_comment" in ele) {
                stringObj += "fetch_comment:" + ele.fetch_comment + ",";
            }
            if ("news_config" in ele) {
                stringObj += "news_config:" + ele.news_config + ",";
            }
            if (ele.country) {
                stringObj += "country:" + ele.country + ",";
            }
            if (ele.entity_sub_type) {
                stringObj += "entity_sub_type:" + ele.entity_sub_type + ",";
            }
            if (ele.account_type) {
                stringObj += "account_type:" + ele.account_type + ",";
            }
            if (tableData.length - 1 !== ind) {
                stringObj += "\n";
            }
        });

        props.setAccountListData([...tableData]);
        props.setBulkFileldValue(stringObj);
    };

    const deletePost = (ind) => {
        let tableData = [...props.postListData];
        //Delete one element from the selected index
        tableData.splice(ind, 1);

        props.setPostListData([...tableData]);
    };

    const changeAccountStatus = () => {
        if (props.isAccountValid == true) {
            props.setValidAccount(false);
        }
    };

    const onHandleChangeStatus = (ev) => {
        setStatusOption(ev);
        setStatusText(ev.value);
    };

    const customFlagRenderer = (_flagMiss, name) => {
        if (name === "Curacao") {
            return (
                <span>
                    <CuraCao className="custom-icon" />
                </span>
            );
        } else if (name === "Bonaire, Sint Eustatius and Saba") {
            return (
                <span>
                    <BonaireIcon className="custom-icon" />
                </span>
            );
        } else if (name === "Guernsey") {
            return (
                <span>
                    <Guernsey className="custom-icon" />
                </span>
            );
        } else if (name === "Jersey") {
            return (
                <span>
                    <Jersey className="custom-icon" />
                </span>
            );
        } else if (name === "Isle of Man") {
            return (
                <span>
                    <Isleofman className="custom-icon" />
                </span>
            );
        } else if (name === "Millennium Bostonian") {
            return (
                <span>
                    <Bostonian className="custom-icon" />
                </span>
            );
        } else if (name === "Saint Martin") {
            return (
                <span>
                    <SintMarteen className="custom-icon" />
                </span>
            );
        } else if (name === "Sint Maarten") {
            return (
                <span>
                    <SintMarteen className="custom-icon" />
                </span>
            );
        } else if (name === "Saint Barthelemy") {
            return (
                <span>
                    <SaintBarthelemy className="custom-icon" />
                </span>
            );
        } else if (name == "Worldwide") {
            return (
                <span>
                    <GlobeIcon className="custom-icon" />
                </span>
            );
        } else if (name === "South Sudan") {
            return (
                <span>
                    <SouthSudan className="custom-icon" />
                </span>
            );
        } else if (name == "Unknown") {
            return (
                <span>
                    <UnknownFlag className="custom-icon" />
                </span>
            );
        } else {
            return (
                <span>
                    <GlobeIcon className="custom-icon" />
                </span>
            );
        }
    };

    const flagRenderer = (item) => <Flag name={item} />;

    const formatOptionLabel = ({ value, label, flag, flag_miss }) => (
        <div style={{ display: "flex" }}>
            <div style={{ marginLeft: "0px", color: "#ccc", marginRight: "0px" }}>
                {flag_miss === "yes" ? customFlagRenderer(flag_miss, label) : flagRenderer(flag)}
            </div>
            <div>{label}</div>
        </div>
    );

    const onSearchTextChange = (ev) => {
        setSearchTextValue(ev.target.value);
    };

    const clearSearchFilter = () => {
        setSearchTextValue("");
    };

    // const handleBulkInputChange = (fieldValue) => {
    //     props.setBulkFileldValue(fieldValue);
    //     setCheckIsDirty(true);
    //     if (props.isAccountValid == true) {
    //         props.setValidAccount(false);
    //     }
    // };

    return (
        <>
            <props.component
                {...props}
                clearSearchFilter={clearSearchFilter}
                onSearchTextChange={onSearchTextChange}
                formatOptionLabel={formatOptionLabel}
                onHandleChangeStatus={onHandleChangeStatus}
                deleteAccount={deleteAccount}
                verifyAccount={verifyAccount}
                onAddAccount={onAddAccount}
                handleUrlChange={handleUrlChange}
                handleChUrlChange={handleChUrlChange}
                changeAccountStatus={changeAccountStatus}
                setCheckIsDirty={props.setCheckIsDirty}
                handleLocationChange={handleLocationChange}
                handleEntityTypeChange={handleEntityTypeChange}
                Control={Control}
                activeFilterOptions={activeFilterOptions}
                entityList={entityList}
                getCountryList={getCountryList}
                customStyle={customStyle}
                myStyle={myStyle}
                bulkMode={props.bulkMode}
                searchTextValue={searchTextValue}
                statusOption={statusOption}
                statusText={statusText}
                checkIsDirty={props.setCheckIsDirty}
                isFbComment={isFbComment}
                setIsFbComment={setIsFbComment}
                onAddPost={onAddPost}
                deletePost={deletePost}
                handlePostUrlChange={handlePostUrlChange}
                handlePostCountryChange={handlePostCountryChange}
            />
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        allLocations: state.filterSettingReducer.masterLocations,
        selectedCountryOptions: state.queryBuilderReducer.selectedCountryOptions,
        finalQuery: state.queryBuilderReducer.finalQuery,
        userTimeZone: state.globalReducer.company.user_timezone_name,
        accountName: state.queryBuilderReducer.accountName,
        yTAccountURL: state.queryBuilderReducer.yTAccountURL,
        isAccountValid: state.queryBuilderReducer.isAccountValid,
        verifyingAccount: state.queryBuilderReducer.verifyingAccount,
        addingAccount: state.queryBuilderReducer.addingAccount,
        accountListData: state.queryBuilderReducer.accountListData,
        postListData: state.queryBuilderReducer.postListData,
        isAccountAdded: state.queryBuilderReducer.isAccountAdded,
        entityType: state.queryBuilderReducer.entityType,
        post_url: state.queryBuilderReducer.post_url,
        post_country: state.queryBuilderReducer.post_country,
        location: state.queryBuilderReducer.location,
        bulkInputValue: state.queryBuilderReducer.bulkInputValue,
        bulkMode: state.queryBuilderReducer.bulkMode,
        isRuleCreated: state.queryBuilderReducer.isRuleCreated,
        queryForEdit: state.queryBuilderReducer.queryForEdit,
        isPublication: state.queryBuilderReducer.isPublication,
        fetchComment: state.queryBuilderReducer.fetchComment,
        tiktokRuleName: state.queryBuilderReducer.tiktokRuleName,
        tiktokKeyword: state.queryBuilderReducer.tiktokKeyword,
        validTiktokKeyword: state.queryBuilderReducer.validTiktokKeyword,
        validAccounts: state.queryBuilderReducer.validAccounts,
        validCountry: state.queryBuilderReducer.validCountry,
        validEntity: state.queryBuilderReducer.validEntity,
        fbTokenList: state.tokensReducer.fbTokenList,
        igTokenList: state.tokensReducer.igTokenList,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        validateAccount: (data, platform) => dispatch(validateAccount(data, platform)),
        // validateTiktokAccount: (data) => dispatch(validateTiktokAccount(data)),
        setValidAccount: (data) => dispatch(setValidAccount(data)),
        setAccountListData: (data) => dispatch(setAccountListData(data)),
        setPostListData: (data) => dispatch(setPostListData(data)),
        setAccountList: (data) => dispatch(setAccountList(data)),
        resetAccountForm: () => dispatch(resetAccountForm()),
        setAccount: (data) => dispatch(setAccount(data)),
        setAccountURL: (data) => dispatch(setAccountURL(data)),
        setEntity: (data) => dispatch(setEntity(data)),
        setTiktokKeyword: (data) => dispatch(setTiktokKeyword(data)),
        setTiktokRuleName: (data) => dispatch(setTiktokRuleName(data)),
        setAccountLocation: (data) => dispatch(setAccountLocation(data)),
        setPublication: () => dispatch(setPublication()),
        setPullComments: () => dispatch(setPullComments()),
        setBulkFileldValue: (data) => dispatch(setBulkFileldValue(data)),
        setPostUrl: (data) => dispatch(setPostUrl(data)),
        setPostCountry: (data) => dispatch(setPostCountry(data)),
        setValidCountry: (data) => dispatch(setValidCountry(data)),
        setValidEntity: (data) => dispatch(setValidEntity(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlatformWrapper);
